import { render, staticRenderFns } from "./AddLand.vue?vue&type=template&id=9264e680"
import script from "./AddLand.vue?vue&type=script&lang=js"
export * from "./AddLand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports